export default "__VITE_ASSET__99163b4a__"